module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAv0lEQVQ4T+2TsRHCMAxF/9+AFdgANuBXtFmBTRiBEdgAJohScZSMACUVdJTixMU5x0kYgMO135MsfxFfjpntAVwk7aau8ZugruuGZCNp+xf85AzMbCbp+cmBmR0BPCRt8v8ey0GAgQC4SaqSYOHuEZpDLikFCXZ3kqwkXbskmtlAkgsKeBXtR7e9KJeSJAAQu2Bt5Q4eCNp5dJ24+5zkGcB6DB4V5BIAL5Jw9zvJXuU07MltbJ9zAhDwMr253Mo3CyeiEZgn4AkAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/dow/nrxt.png
// module id = uRWg
// module chunks = 0